import React, { useRef } from "react";
import { GradientBorderContainer } from "@src/components/templates/layouts/gradient-border-container/gradient-border-container";
import styles from "./dashboard-card-popover.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { ButtonWithIcon } from "../buttons/button-with-icon/button-with-icon";
import renameIconGreen from "@src/assets/svg/rename-icon-green.svg";
import duplicateIcon from "@src/assets/svg/duplicate-icon.svg";
import deleteRedIcon from "@src/assets/svg/delete-red-icon.svg";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { useI18N } from "@src/language/language-context";

interface DashboardCardPopoverProps {
  onRename: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  setPopoverIsOpen: (state: boolean) => void;
}

const cssClassName = "dashboard-card-popover";

export const DashboardCardPopover = ({
  onRename,
  onDuplicate,
  onDelete,
  setPopoverIsOpen,
}: DashboardCardPopoverProps) => {
  const i18n = useI18N();

  const texts = {
    rename: i18n("modules.dashboardCard.rename"),
    duplicate: i18n("modules.dashboardCard.duplicate"),
    delete: i18n("modules.dashboardCard.delete"),
  };

  const popoverRef = useRef<HTMLDivElement>(null);
  useClickOutsideListener(popoverRef, () => setPopoverIsOpen(false), true);

  const run = (fn: () => void) => {
    fn();
    setPopoverIsOpen(false);
  };

  return (
    <div
      ref={popoverRef}
      className={styles[cssClassName]}
      role="menu"
      tabIndex={-1}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <GradientBorderContainer>
        <div className={styles[`${cssClassName}__inner-wrapper`]}>
          <FlexColumnContainer>
            <ButtonWithIcon
              variant={["no-outline", "color-blue"]}
              fun={() => run(onRename)}
              icon={renameIconGreen}
              text={texts.rename}
            />
            <ButtonWithIcon
              variant={["no-outline", "color-blue"]}
              fun={() => run(onDuplicate)}
              icon={duplicateIcon}
              text={texts.duplicate}
            />
            <ButtonWithIcon
              variant={["no-outline", "color-red"]}
              fun={() => run(onDelete)}
              icon={deleteRedIcon}
              text={texts.delete}
            />
          </FlexColumnContainer>
        </div>
      </GradientBorderContainer>
    </div>
  );
};
